export const FormGroupPersonFieldPermissionType = {
  PERSONFIELD_READ_ROLE: 'PERSONFIELD_READ_ROLE',
  PERSONFIELD_EDIT_ROLE: 'PERSONFIELD_EDIT_ROLE',
  PERSONFIELD_HIERARCHY_READ_ROLE: 'PERSONFIELD_HIERARCHY_READ_ROLE',
  PERSONFIELD_HIERARCHY_EDIT_ROLE: 'PERSONFIELD_HIERARCHY_EDIT_ROLE',
  PERSONFIELD_ATTACHMENT_READ_ROLE: 'PERSONFIELD_ATTACHMENT_READ_ROLE',
  PERSONFIELD_ATTACHMENT_EDIT_ROLE: 'PERSONFIELD_ATTACHMENT_EDIT_ROLE',
  PERSONFIELD_VERSION_READ_ROLE: 'PERSONFIELD_VERSION_READ_ROLE',
  PERSONFIELD_VERSION_EDIT_ROLE: 'PERSONFIELD_VERSION_EDIT_ROLE',
  PERSONFIELD_INVITATION_READ_ROLE: 'PERSONFIELD_INVITATION_READ_ROLE',
  PERSONFIELD_INVITATION_EDIT_ROLE: 'PERSONFIELD_INVITATION_EDIT_ROLE',
} as const;
export type FormGroupPersonFieldPermissionType =
  (typeof FormGroupPersonFieldPermissionType)[keyof typeof FormGroupPersonFieldPermissionType];

export const FormGroupPermissionType = {
  Read: 'READ',
  Edit: 'EDIT',
} as const;
export type FormGroupPermissionType = (typeof FormGroupPermissionType)[keyof typeof FormGroupPermissionType];
